import { render, staticRenderFns } from "./insertGoods.vue?vue&type=template&id=182a7919&scoped=true&"
import script from "./insertGoods.vue?vue&type=script&lang=js&"
export * from "./insertGoods.vue?vue&type=script&lang=js&"
import style0 from "./insertGoods.vue?vue&type=style&index=0&id=182a7919&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182a7919",
  null
  
)

export default component.exports